module.exports = __webpack_public_path__ + "img/footerLogo.21272654.gif";